<template>
  <div class="login-page">
    <!-- banner -->
    <div class="banner">
      <img src="../assets/images/login-banner.png" alt="" />
    </div>
    <!-- 登录 -->
    <div class="login">
      <div class="login-title">小铃铛陪护服务</div>
      <div class="login-input flex-colc">
        <input
          type="number"
          placeholder="请输入手机号码"
          v-model.number="get_staff_contact"
          @keyup.enter="handleLogin"
        />
      </div>
      <div
        class="login-button"
        :class="{ disabled: isSubmitting }"
        @click="handleLogin"
      >
        {{ isSubmitting ? "登录中..." : "登录" }}
      </div>
    </div>
  </div>
</template>
  <script>
import { verifyDispatch } from "../api/api";
export default {
  name: "EscortVerify",
  data() {
    return {
      get_staff_contact: '',
      // 新增是否提交中的状态
      isSubmitting: false,
    };
  },
  methods: {
    async handleLogin() {
      console.log(this.$route.query);
      
      // 如果正在提交，直接返回
      if (this.isSubmitting) return; // 防止重复提交

      try {
        let { get_staff_contact } = this;
        // 验证手机号是否为空
        if (!get_staff_contact) {
          this.$toast("请输入手机号");
          return;
        }
        // 验证手机号格式是否正确
        if (!/^1[3456789]\d{9}$/.test(get_staff_contact)) {
          this.$toast("请输入正确的手机号");
          return;
        }
        // 设置为提交中
        this.isSubmitting = true;
        this.$toast.loading({
          message: "登录中...",
          forbidClick: true,
          duration: 0, // 持续时间为 0，防止自动关闭
        });
        let params = {
          get_staff_contact,
          order_id: this.$route.query.order_id,
        }

        const res = await verifyDispatch(params);

        // 等待1秒
        await new Promise((resolve) => setTimeout(resolve, 500));
        if (res.result) {
          // 如果是业务员
          if(res.user && res.user.openid) {
            this.$store.commit("updateOpenid", res.user.openid);
            let user_obj = {
              openid: res.user.openid,
              order_id: res.data.order_id,
              truename: res.data.get_staff_name,
              accountid: res.data.get_staff_id,
              mobile: res.data.get_staff_contact,
              servicecont: res.servicecont,
              id: res.id
            }
            this.$store.commit("updateUserInfo", user_obj);
          }
          // 如果是合作机构
          if(res.bell_institution && res.bell_institution.guid) {
            this.$store.commit("updateOpenid", res.bell_institution.guid);
            let bell_institution_obj = {
              openid: res.bell_institution.guid,
              order_id: res.data.order_id,
              truename: res.data.get_staff_name,
              accountid: res.data.get_staff_id,
              mobile: res.data.get_staff_contact,
              servicecont: res.servicecont,
              id: res.id
            }
            this.$store.commit("updateUserInfo", bell_institution_obj);
          }
          // 根据用户信息是否获取成功进行跳转
          if (this.$store.state.USERINFO && this.$store.state.USERINFO.mobile) {
            // 关闭加载提示
            this.$toast.clear();
            // this.$router.push("/home/escort");
            this.handleDetail(res)
          } else {
            // 用户信息获取失败，提示并跳转回登录页
            this.$toast.fail("用户信息获取失败，请重新登录");
            this.$store.commit("updateOpenid", "");
            this.$store.commit("updateUserInfo", "");
            // 无论成功或失败，都将提交状态设置为 false
            this.isSubmitting = false;
          }
        } else {
          // 无论成功或失败，都将提交状态设置为 false
          this.isSubmitting = false;
          // 关闭加载提示
          //   this.$toast.clear();
          this.$toast.fail(res.msg || "接口失效，请稍后～");
        }
      } catch (e) {
        // 无论成功或失败，都将提交状态设置为 false
        this.isSubmitting = false;
        this.$toast.fail("登录请求出错，请稍后重试");
      } 
    },

    handleDetail(item) {
      const routeMap = {
        3: "OrderReportDetailDispatch",
        11: "MedicineDispatchDetailDispatch",
        12: "InquiryAgencyDetailDispatch",
        13: "AppointmentCheckDetailDispatch",
        14: "InHospitalDetailDispatch",
        15: "InHospitalInDetailDispatch"
      };

      const routeName = routeMap[item.servicecont] || "OrderDetailDispatch";

      this.$router.push({
        name: routeName,
        query: { id: item.id }
      });
    },
  },
};
</script>
  <style lang="less">
.login-page {
  height: 100vh;
  background: #fff;
  .login {
    .login-title {
      font-size: 36px;
      color: #0031c9;
      text-align: center;
      font-weight: bold;
      margin: 73px auto 58px;
    }
    .login-input {
      input {
        width: 600px;
        height: 90px;
        border: 1px solid #adadad;
        border-radius: 45px;
        font-size: 24px;
        text-align: center;
        margin-bottom: 40px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .login-button {
      margin: 87px auto 70px;
      width: 300px;
      height: 90px;
      text-align: center;
      line-height: 90px;
      background: #0031c9;
      border-radius: 45px;
      font-size: 30px;
      color: #fff;
      &.disabled {
        background: #ccc;
        cursor: not-allowed;
      }
    }
    .login-footer {
      font-size: 24px;
      color: #464646;
      text-align: center;
      .login-footer-top {
        margin-bottom: 59px;
      }
    }
  }
}
</style>